<template>
  <div
    class="header"
    id="header2"
    :style="{ background: scroll >= 50 ? 'rgba(0, 0, 0, 0.8)' : '' }"
  >
    <div
      class="container"
      style="display: flex; align-items: center; justify-content: space-between;height:100%;"
    >
      <div class="logo">
        <img src="@/images/common/logo.png" alt="" />
      </div>
      <div class="nav_right">
        <div
          v-for="item in nav"
          :key="item.id"
          class="navItem"
          @click="toRouer(item)"
        >
          <div>{{ item.name }}</div>
          <div :style="{ background: (item.isfalse) ? scroll >= 50?'#ffffff' : '#376bf6':'none' }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
      scroll: "",
    };
  },
  computed: {},
  watch: {},
  props: {
    nav: {
      type: Array,
      default: () => { }
    }
  },
  mounted() {
    let _this=this
    window.onscroll = function () {
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        _this.scroll = scrollTop;
    };
  },
  methods: {
    toRouer(item) {
      this.nav.forEach((val,index) => {
        if (val.id == item.id) {
          val.isfalse = true;
          this.$emit('accept',index)
        } else {
          val.isfalse = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.header {
  position: fixed;
  width: 100%;
  height: 78px;
  font-size: 16px;
  z-index: 999;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.logo {
  cursor: pointer;
}
.logo img {
  width: 300px;
  /* margin-top: calc((0.77rem - 58px) / 2); */
}
.nav_right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav_right .navItem {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-right: 0.5rem;
}
.navItem :first-child {
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  cursor: pointer;
}
.navItem :last-child {
  width: 16px;
  height: 4px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue